module.exports = __webpack_public_path__ + "static/media/retirement.2f24c6ef.svg";